__turbopack_context__.v({
  "actions": "NotificationCard-module-scss-module__nOwe_G__actions",
  "body": "NotificationCard-module-scss-module__nOwe_G__body",
  "card": "NotificationCard-module-scss-module__nOwe_G__card",
  "content": "NotificationCard-module-scss-module__nOwe_G__content",
  "description": "NotificationCard-module-scss-module__nOwe_G__description",
  "emphasis": "NotificationCard-module-scss-module__nOwe_G__emphasis",
  "header": "NotificationCard-module-scss-module__nOwe_G__header",
  "timestamp": "NotificationCard-module-scss-module__nOwe_G__timestamp",
  "title": "NotificationCard-module-scss-module__nOwe_G__title",
  "titleRow": "NotificationCard-module-scss-module__nOwe_G__titleRow",
  "unreadDot": "NotificationCard-module-scss-module__nOwe_G__unreadDot",
});
